import { PlayCircleIcon, PauseCircleIcon } from '@heroicons/react/20/solid'
import { formatSeconds } from 'util/time'
import { CondensedSentence } from 'util/transcript/condense-transcript'
import { useEffect, useState } from 'react'
import { classNames } from 'util/classNames'

export const SentenceHeading = ({
  sentence,
  handleEditSpeaker,
  isPlaying,
  setAudioTime,
  progress,
  pause,
  play,
  editable = true,
}: {
  sentence: CondensedSentence
  handleEditSpeaker: (speaker: string) => void
  isPlaying: boolean
  setAudioTime: (startTime: number, endTime?: number) => void
  progress: number
  pause: () => void
  play: () => void
  editable?: boolean
}) => {
  const [isCurrentSentence, setIsCurrentSentence] = useState(false)

  useEffect(() => {
    if (progress >= sentence.start / 1000 && progress <= sentence.end / 1000) {
      setIsCurrentSentence(true)
    } else {
      setIsCurrentSentence(false)
    }
  }, [progress, sentence.end, sentence.start])

  const handlePlay = () => {
    setAudioTime(sentence.start / 1000, sentence.end / 1000)
    play()
  }

  return (
    <div
      className={classNames(
        'flex select-none flex-col justify-between',
        editable ? 'pl-2' : 'pl-0'
      )}
    >
      <div className="flex items-center">
        {isPlaying && isCurrentSentence ? (
          <PauseCircleIcon
            className="mr-2 h-5 w-5 cursor-pointer text-blue-200 hover:text-toasty-blue-500"
            onClick={pause}
          />
        ) : (
          <PlayCircleIcon
            className="mr-2 h-5 w-5 cursor-pointer text-blue-200 hover:text-toasty-blue-500"
            onClick={handlePlay}
          />
        )}
        {sentence.speaker && (
          <span
            className={classNames(
              'mr-6 text-sm font-semibold text-toasty-blue-500',
              editable ? 'cursor-pointer hover:underline' : ''
            )}
            onClick={() => handleEditSpeaker(sentence.speaker)}
          >
            {sentence.speaker}
          </span>
        )}
        <span className="text-sm text-gray-500">
          {formatSeconds(sentence.start)} - {formatSeconds(sentence.end)}
        </span>
      </div>
    </div>
  )
}
